import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { AppBadge } from '../ui';

/**
 * Badge compact « N sem. » + popover détaillé (position avant/après + liste des semaines).
 */
const KkpClientWeekSpanBadge = ({ spanBadge, id }) => {
  if (!spanBadge) return null;

  const {
    label,
    totalWeeks,
    position,
    weekLabels,
    relativeSummary,
  } = spanBadge;

  const popover = (
    <Popover id={id || 'kkp-client-week-span'} className="kkp-client-week-span-popover">
      <Popover.Header as="div" className="kkp-client-week-span-popover__header">
        {totalWeeks} semaines d’affilée
      </Popover.Header>
      <Popover.Body className="kkp-client-week-span-popover__body">
        <p className="kkp-client-week-span-popover__position">
          Cette ligne : <strong>{position}/{totalWeeks}</strong>
        </p>
        <p className="kkp-client-week-span-popover__relative">
          {relativeSummary}
        </p>
        <p className="kkp-client-week-span-popover__list-title">Semaines concernées</p>
        <ul className="kkp-client-week-span-popover__list">
          {weekLabels.map((weekLabel, index) => {
            const isCurrent = index + 1 === position;
            return (
              <li
                key={`${weekLabel}-${index}`}
                className={isCurrent ? 'is-current' : undefined}
              >
                <span className="kkp-client-week-span-popover__week-label">{weekLabel}</span>
                {isCurrent ? (
                  <span className="kkp-client-week-span-popover__current-tag">cette ligne</span>
                ) : null}
              </li>
            );
          })}
        </ul>
      </Popover.Body>
    </Popover>
  );

  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      placement="top"
      delay={{ show: 150, hide: 80 }}
      overlay={popover}
    >
      <span
        className="kkp-client-week-span-badge-wrap d-inline-flex"
        tabIndex={0}
        role="button"
        aria-label={`${label} — ${relativeSummary}`}
      >
        <AppBadge
          variant="info"
          pill
          className="kkp-client-week-span-badge fw-normal"
        >
          {label}
        </AppBadge>
      </span>
    </OverlayTrigger>
  );
};

export default KkpClientWeekSpanBadge;
